
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPassedFill as ObiPassedFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-passed-fill.js';
 
 
 

 
 export const ObiPassedFill = createComponent({
   react: React,
   tagName: 'obi-passed-fill',
   elementClass: ObiPassedFillElement,
   events: {
     
   }
  });
 
 